export const TEXT_ME_THE_APP_KEY = 'textMeTheApp';
